import { Component } from '@angular/core';
import BaseDetailPageConfig from '../../../../models/base-detail-page.config';
import { ItemTypesService } from '../../../../services/api/general-settings/item-types.service';
import { BaseDetailPageComponent } from '../../../../components/pages/base-detail-page/base-detail-page.component';
import { RouteService } from '../../../../services/route.service';

@Component({
  selector: 'app-item-types-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './item-types-detail-page.component.html',
  styleUrl: './item-types-detail-page.component.scss'
})
export class ItemTypesDetailPageComponent {
  baseDetailPageConfig!: BaseDetailPageConfig;
  readonlyUserDetail: boolean

  ItemType?: any;

  constructor(
    private itemTypesService: ItemTypesService,
    private routeService: RouteService
  ) {
    this.readonlyUserDetail = true
  }

  ngOnInit(): void {

    this.baseDetailPageConfig = {
      pageTitle: 'Item Types',
      cardTitle: 'Item Types Detail',
      editItemButton: {
        type: 'success',
        title: 'Edit Item Type',
        onClick: () => {
          this.routeService.itemTypesUpdate(this.ItemType.id)
        }
      },
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'code',
            label: 'Code',
            value: (item: any) => {
              return item.code;
            }
          },
          {
            attribute: 'name',
            label: 'Name',
            value: (item: any) => {
              return item.name;
            }
          },
        ]
      },
      apiDetailService: (ItemTypeId: number) => this.itemTypesService.detail(ItemTypeId),
      routeParamName: 'itemTypeId',
      responseModelName: 'itemType'
    };

  }

  onLoadedDetail(data: any) {
    this.ItemType = data;
  }
}
